// removed by extract-text-webpack-plugin
module.exports = {"form":"styles__form___1G6Sz","buttonsContainer":"styles__buttonsContainer___31RI0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModernEmailModal/components/EmailModalForm/styles.css
// module id = 2583
// module chunks = 0